import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DhukanDataService } from 'src/app/services/dhukan/dhukan-data.service';

@Component({
  selector: 'app-selectdeliverypartner',
  templateUrl: './selectdeliverypartner.component.html',
  styleUrls: ['./selectdeliverypartner.component.css']
})
export class SelectdeliverypartnerComponent implements OnInit {

  @Input() restaurantdeliverypartnercoll: any = [];
  @Input() restaurantid: any = 0;
  @Output() emitData = new EventEmitter();

  constructor(
    private toastr: ToastrService, 
    private appService: DhukanDataService,
    private activeModal: NgbActiveModal
  ) { }

  ngOnInit() {
  }

  checkValue(values: any, index) {
    this.restaurantdeliverypartnercoll[index].ischeck = values.currentTarget.checked;
  }

  fnUpdatePartner() {
    this.emitData.emit(this.restaurantdeliverypartnercoll);
    this.activeModal.close(true);
  }

  public decline() {
    this.activeModal.close(false);
  }
}